module.exports = __webpack_public_path__ + "img/applyImg.4889fc58.png";